import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  rootAppMenu: {
    "& ul": {
      padding: 0
    }
  }
}))